import { atomsLabelColorObjs } from '../constants/colors'

// メーカーラベル
const atomsLabelBase = (ctx: CanvasRenderingContext2D, baseColor: string, outOfEdgeColor: string, x: number, y: number): void => {
  ctx.lineWidth = 4.0
  ctx.strokeStyle = outOfEdgeColor
  // メインカラー↓
  ctx.beginPath()
  ctx.fillStyle = baseColor
  ctx.moveTo(344 + x, 583 + y) // 左下
  ctx.lineTo(389 + x, 584 + y) // 左下の右
  ctx.quadraticCurveTo(423 + x, 548 + y, 433 + x, 548 + y) //  真ん中中央
  ctx.quadraticCurveTo(450 + x, 580 + y, 452 + x, 580 + y) // 右下の左
  ctx.lineTo(481 + x, 577 + y) // 右下の右
  ctx.quadraticCurveTo(490 + x, 565 + y, 494 + x, 548 + y) // 右下の右上1
  ctx.quadraticCurveTo(495 + x, 543 + y, 486 + x, 545 + y) // 右下の右上2
  ctx.quadraticCurveTo(474 + x, 559 + y, 469 + x, 559 + y) //
  ctx.lineTo(454 + x, 534 + y) //

  ctx.quadraticCurveTo(481 + x, 520 + y, 494 + x, 508 + y) // 右上1
  ctx.quadraticCurveTo(499 + x, 497 + y, 488 + x, 499 + y) // 右上2
  ctx.quadraticCurveTo(471 + x, 512 + y, 447 + x, 523 + y) //
  ctx.lineTo(427 + x, 492 + y) // 中央の上

  ctx.lineTo(382 + x, 492 + y) //左上1
  ctx.quadraticCurveTo(375 + x, 492 + y, 378 + x, 497 + y) //左上2
  ctx.lineTo(398 + x, 506 + y)
  ctx.quadraticCurveTo(374 + x, 561 + y, 374 + x, 561 + y)
  ctx.lineTo(345 + x, 577 + y)
  ctx.quadraticCurveTo(345 + x, 579 + y, 344 + x, 583 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const edgeLine = (ctx: CanvasRenderingContext2D, edgeColor: string, x: number, y: number) => {
  ctx.lineWidth = 2.5
  ctx.strokeStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(347 + x, 580 + y) // 左下
  ctx.lineTo(387 + x, 581 + y) // 右
  ctx.quadraticCurveTo(404 + x, 564 + y, 433 + x, 545 + y) //
  ctx.quadraticCurveTo(444 + x, 567 + y, 452 + x, 577 + y) //
  ctx.lineTo(480 + x, 574 + y) // 右下_右
  ctx.quadraticCurveTo(489 + x, 562 + y, 492 + x, 547 + y) // 右上_右
  ctx.lineTo(486 + x, 547 + y) // 右上_左
  ctx.quadraticCurveTo(477 + x, 560 + y, 467 + x, 561 + y) //
  ctx.lineTo(449 + x, 533 + y) //
  ctx.quadraticCurveTo(477 + x, 518 + y, 491 + x, 506 + y) //
  ctx.quadraticCurveTo(496 + x, 498 + y, 487 + x, 501 + y) //
  ctx.quadraticCurveTo(474 + x, 512 + y, 445 + x, 526 + y) //
  ctx.lineTo(424 + x, 494 + y) // 中央_上
  ctx.lineTo(384 + x, 494 + y) // 左上1
  ctx.quadraticCurveTo(378 + x, 494 + y, 382 + x, 496 + y) // 左上2
  ctx.lineTo(402 + x, 505 + y) //
  ctx.lineTo(376 + x, 562 + y) //
  ctx.quadraticCurveTo(346 + x, 580 + y, 347 + x, 580 + y) //

  ctx.stroke()
  ctx.closePath()
}
// 本体革カラー↓(中央のくり抜き)
const hollowOutOfAtomsLabel = (ctx: CanvasRenderingContext2D, edgeColor: string, outOfEdgeColor: string, x: number, y: number) => {
  ctx.lineWidth = 2.5
  ctx.strokeStyle = edgeColor
  ctx.fillStyle = outOfEdgeColor
  ctx.beginPath()
  ctx.moveTo(401 + x, 550 + y) // 左下
  ctx.lineTo(425 + x, 536 + y) // 右
  ctx.lineTo(416 + x, 521 + y) // 上
  ctx.lineTo(401 + x, 550 + y) // 左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const atomsLabel = (ctx: CanvasRenderingContext2D, value: string, x: number, y: number, numerator: number, scaleSize: number): void => {
  const colorObject = atomsLabelColorObjs.filter((object) => object.value === value)[0]
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  ctx.scale(scaleSize, scaleSize)
  atomsLabelBase(ctx, colorObject?.core || '#eee', colorObject?.outOfEdge || '#eee', x, y)
  edgeLine(ctx, colorObject?.edge || '#eee', x, y)
  hollowOutOfAtomsLabel(ctx, colorObject?.edge || '#eee', colorObject?.outOfEdge || '#eee', x, y)
  ctx.restore()
}

// 捕球面の刻印
export const atomsEngravedOfCatchFaceOfJaModel = (ctx: CanvasRenderingContext2D, x: number, y: number, catchFaceColor: string): void => {
  const isBright = [
    'black',
    'kBlack',
    'uBlack',
    'jBlack',
    'navy',
    'blue',
    'red',
    'cork',
    'jCork',
    'uCork',
    'kCork',
    'purple',
    'chocolate',
    'green',
    'teal',
    'gray'
    // 'silver'
  ].includes(catchFaceColor)
  ctx.lineWidth = 0.8
  // ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.strokeStyle = isBright ? '#eee' : '#ddd'
  // ctx.fillStyle = 'pink'
  ctx.lineWidth = 4.0
  ctx.beginPath()
  // A
  ctx.moveTo(403 + x, 442 + y) // 左下
  ctx.lineTo(425 + x, 417 + y) // 上
  ctx.moveTo(425 + x, 417 + y) // 上
  ctx.lineTo(422 + x, 449 + y) // 右下
  ctx.moveTo(403 + x, 437 + y) // 左
  ctx.lineTo(426 + x, 439 + y) // 右
  // T
  ctx.moveTo(425 + x, 421 + y) // 左
  ctx.quadraticCurveTo(440 + x, 416 + y, 458 + x, 420 + y) // 右
  ctx.moveTo(440 + x, 419 + y) // 上
  ctx.quadraticCurveTo(442 + x, 436 + y, 439 + x, 450 + y) // 下
  // O
  ctx.moveTo(457 + x, 423 + y) // 左上
  ctx.quadraticCurveTo(450 + x, 446 + y, 464 + x, 449 + y) // 下
  ctx.quadraticCurveTo(481 + x, 450 + y, 476 + x, 425 + y) // 右上
  ctx.quadraticCurveTo(468 + x, 413 + y, 457 + x, 423 + y) // 左上
  // M
  ctx.moveTo(479 + x, 420 + y) // 左上
  ctx.quadraticCurveTo(481 + x, 452 + y, 481 + x, 452 + y) // 左下
  ctx.moveTo(479 + x, 420 + y) // 左上
  ctx.quadraticCurveTo(479 + x, 433 + y, 490 + x, 440 + y) // 中央下
  ctx.moveTo(498 + x, 419 + y) // 右上
  ctx.quadraticCurveTo(496 + x, 431 + y, 490 + x, 440 + y) // 中央下
  ctx.moveTo(498 + x, 419 + y) // 右上
  ctx.quadraticCurveTo(499 + x, 437 + y, 497 + x, 451 + y) // 右下
  // S
  ctx.moveTo(508 + x, 445 + y) // 左下
  ctx.quadraticCurveTo(520 + x, 458 + y, 529 + x, 444 + y) // 中央下
  ctx.quadraticCurveTo(535 + x, 433 + y, 518 + x, 433 + y) // S字の中央
  ctx.quadraticCurveTo(500 + x, 434 + y, 502 + x, 428 + y) // 左上
  ctx.quadraticCurveTo(505 + x, 421 + y, 525 + x, 420 + y) // 右上
  ctx.stroke()
  ctx.closePath()
}

export const atomsEngravedOfCatchFaceOfUsModel = (ctx: CanvasRenderingContext2D, x: number, y: number, catchFaceColor: string): void => {
  const isBright = [
    'black',
    'kBlack',
    'uBlack',
    'jBlack',
    'navy',
    'blue',
    'red',
    'cork',
    'jCork',
    'uCork',
    'kCork',
    'purple',
    'chocolate',
    'green',
    'teal',
    'gray'
    // 'silver'
  ].includes(catchFaceColor)
  ctx.lineWidth = 0.8
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  // ctx.fillStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.beginPath()
  ctx.lineWidth = 4.0
  ctx.font = '40px serif'
  ctx.strokeText(`先駆者`, 410 + x, 400 + y)
  ctx.lineWidth = 1.5
  ctx.font = '10px serif'
  // ctx.strokeText(`ATOMS と Davis Relacing`, 415 + x, 400 + y)
  ctx.stroke()
  ctx.closePath()
  atomsEngravedOfCatchFaceOfJaModel(ctx, x, y, catchFaceColor) // 中国販売用
}

export const atomsEngravedOfBackFace = (ctx: CanvasRenderingContext2D, x: number, y: number, rotate: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#888888'
  ctx.save()
  ctx.rotate((rotate * Math.PI) / 180)

  ctx.beginPath()
  ctx.font = '16px Damion'
  ctx.textAlign = 'start'
  ctx.strokeText(`ERM-Wrist`, 360 + x, 550 + y)
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}
